export default __webpack_public_path__ + "static/moonshotbots-10ed70fe7d391337c11f96b7720cfdf5.jpg";